import React from 'react'

const planosRoutes = [
    {
        path: '/planos',
        exact: true,
        component: React.lazy(() => import('./lista/CupomExclusivoIndex')),
    },
    {
        path: '/planos/cadastrar',
        exact: true,
        component: React.lazy(() => import('./cadastrar/PlanosForm')),
    },
    {
        path: '/planos/editar/:planoId',
        exact: true,
        component: React.lazy(() => import('./cadastrar/PlanosForm')),
    },
    {
        path: '/cupons/exclusivos/visualizar/:cupomId',
        exact: true,
        component: React.lazy(() => import('../cupons/exclusivos/gerar/CupomExclusivoForm')),
    },
    {
        path: '/cupons/pontos/listar',
        exact: true,
        component: React.lazy(() => import('../cupons/pontos/listar/CupomPontosIndex')),
    },
    {
        path: '/cupons/pontos/gerar',
        exact: true,
        component: React.lazy(() => import('../cupons/pontos/gerar/CupomPontosForm')),
    },
    {
        path: '/cupons/pontos/editar/:campanhaId',
        exact: true,
        component: React.lazy(() => import('../cupons/pontos/gerar/CupomPontosForm')),
    },
    {
        path: '/cupons/pontos/visualizar/:campanhaId',
        exact: true,
        component: React.lazy(() => import('../cupons/pontos/visualizar/CupomPontosIndex')),
    },
    {
        path: '/cupons/resgates',
        exact: true,
        component: React.lazy(() => import('../cupons/resgates/lista/Table')),
    },
    {
        path: '/cupons/resgates/view',
        exact: true,
        component: React.lazy(() => import('../cupons/resgates/form/Form')),
    },
]

export default planosRoutes
